<template>
    <div :class="color ? 'not-fill' : 'fill'">
    <svg width="100" height="10" viewBox="0 0 100 10" :fill="color" xmlns="http://www.w3.org/2000/svg">
        <rect width="100" height="10" rx="5" ry="5" :fill="color" />
    </svg>
    </div>
</template>
<script>
export default {
    name: "RoundedLine",
    props: ["color"],
};
</script>
<style scoped>
svg {
    fill: var(--header-text-color);
}
</style>




// WEBPACK FOOTER //
// src/components/V2/svg/components/ArrowL.vue